import { useMemo } from "react";
import { useParams } from "react-router-dom";

import { getAppPaths } from "@app/routes/app-paths";
import { useFlag } from "@unleash/proxy-client-react";
import { Database, Folders, User } from "lucide-react";

import { MenuLink } from "./menu-link";
import { MenuLinkHome } from "./menu-link-home";
import { MenuProject } from "./menu-project";
import { Container, Nav, TopNav } from "./styles";

export type MenuProps = {
  hasSystemMessage?: boolean;
};

export const Menu = ({ hasSystemMessage }: MenuProps) => {
  const appPaths = useMemo(() => {
    return getAppPaths();
  }, []);
  const showSsdiDataset = useFlag("ssdi_dataset");
  const { pId: projectId } = useParams();

  return (
    <Container hasSystemMessage={hasSystemMessage}>
      <Nav>
        <MenuLinkHome />

        <TopNav>
          {!projectId ? (
            <>
              <MenuLink url={`/${appPaths.projects}`} title="All Projects" testLabel={"project-page"}>
                <Folders size="lg" />
              </MenuLink>
              {showSsdiDataset && (
                <MenuLink url={`/${appPaths.ssdi}`} title="Data Management" testLabel={"ssdi-page"}>
                  <Database size="lg" />
                </MenuLink>
              )}
            </>
          ) : (
            <MenuProject projectId={projectId} />
          )}
        </TopNav>

        <MenuLink url={`/${appPaths.account}`} title="Account" testLabel={"account-link"}>
          <User size="lg" />
        </MenuLink>
      </Nav>
    </Container>
  );
};
